import { useState } from 'react'
import { Heart } from 'lucide-react'
import veohmoLogopng from '../assets/veohmologo.png'

/**
 * Reusable VeoHMO Logo Component
 * @param {Object} props
 * @param {string} props.size - Size variant: 'small' | 'medium' | 'large' | 'xlarge' | '2xl' | '3xl'
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.showFallback - Whether to show Heart icon fallback on error
 * @param {Function} props.onClick - Click handler (makes logo clickable)
 */
export default function VeoHmoLogo({ 
  size = 'medium', 
  className = '', 
  showFallback = true,
  onClick 
}) {
  const [logoError, setLogoError] = useState(false)

  // Size mappings
  const sizeClasses = {
    small: 'h-8 w-auto',
    medium: 'h-12 w-auto',
    large: 'h-20 w-auto',
    xlarge: 'h-32 w-auto',
    '2xl': 'h-40 w-auto',
    '3xl': 'h-48 w-auto'
  }

  const containerClasses = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-20 h-20',
    xlarge: 'w-32 h-32',
    '2xl': 'w-40 h-40',
    '3xl': 'w-48 h-48'
  }

  const fallbackIconSizes = {
    small: 'w-6 h-6',
    medium: 'w-8 h-8',
    large: 'w-16 h-16',
    xlarge: 'w-24 h-24',
    '2xl': 'w-32 h-32',
    '3xl': 'w-40 h-40'
  }

  const sizeClass = sizeClasses[size] || sizeClasses.medium
  const containerClass = containerClasses[size] || containerClasses.medium
  const iconSize = fallbackIconSizes[size] || fallbackIconSizes.medium

  const handleError = () => {
    setLogoError(true)
  }

  const logoContent = (
    <div className={`relative flex items-center justify-center ${className}`}>
      {veohmoLogopng && !logoError ? (
        <img 
          src={veohmoLogopng} 
          alt="VeoHMO Logo" 
          className={`${sizeClass} object-contain max-w-full`}
          onError={handleError}
        />
      ) : showFallback ? (
        <Heart className={`${iconSize} text-primary-600 fill-primary-600`} />
      ) : null}
    </div>
  )

  if (onClick) {
    return (
      <button 
        onClick={onClick}
        className="focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 rounded"
        aria-label="VeoHMO Home"
      >
        {logoContent}
      </button>
    )
  }

  return logoContent
}

